/* eslint-disable eslint-comments/no-restricted-disable */
/* eslint-disable eslint-comments/no-restricted-disable */

import type { EntryPoint, EntryPointComponent } from 'react-relay';

import { JSResourceForInteraction } from '@atlassian/react-async';
import { createEntryPoint } from '@atlassian/react-entrypoint';
import type { EmbeddedPanelEntrypointEntrypointProps } from './EmbeddedPanelEntrypoint.entrypoint.types.tsx';

type EmbeddedPanelEntrypointComponent = EntryPointComponent<
	{},
	{},
	EmbeddedPanelEntrypointEntrypointProps,
	{}
>;

export const embeddedPanelEntrypoint: EntryPoint<EmbeddedPanelEntrypointComponent, {}> =
	createEntryPoint({
		root: JSResourceForInteraction<EmbeddedPanelEntrypointComponent>(
			/* webpackChunkName: "async-embedded-confluence-panel" */ './EmbeddedPanel.tsx',
		),
		getPreloadProps: () => ({}),
	});
